export const isEmptyOrWhitespace = (str: string) => {
	return str === null || str === undefined || /^\s*$/ig.test(str);
};